<template>
  <div class="account-box">
    <nav-bar
      :title="$t('accountInfo.账号信息')"
      :go-back="
        () => {
          $router.go(-1);
        }
      "
    />
    <div class="top">
      <van-form>
        <van-field
          :value="
            defaultRoleInfo &&
            `${defaultRoleInfo.role_name}(${defaultRoleInfo.server_name})`
          "
          readonly
          type="tel"
          :name="$t('accountInfo.角色')"
          :label="$t('accountInfo.角色')"
        />
      </van-form>
    </div>
    <van-form>
      <van-field
        :value="form.account_info && form.account_info.roleId"
        readonly
        :name="$t('accountInfo.角色ID')"
        :label="$t('accountInfo.角色ID')"
      />
      <van-field
        :value="setCurrentChannel"
        readonly
        :name="$t('accountInfo.渠道')"
        :label="$t('accountInfo.渠道')"
      />
      <template v-if="channelType">
        <van-field
          :value="
            form.phone_info && (form.phone_info.data || form.phone_info.msg)
          "
          readonly
          :name="$t('accountInfo.手机')"
          :label="$t('accountInfo.手机')"
        />
        <!-- <van-field
          :value="form.email"
          readonly
          name="邮箱"
          label="邮箱"
        /> -->
        <van-field
          :value="form.id_status && form.id_status.data"
          readonly
          :name="$t('accountInfo.实名状态')"
          :label="$t('accountInfo.实名状态')"
        />
        <van-field
          :value="form.account_type && form.account_type.data"
          readonly
          :name="$t('accountInfo.三方账号')"
          :label="$t('accountInfo.三方账号')"
        />
      </template>
    </van-form>
    <div style="margin: 16px">
      <van-button block type="primary" size="large" @click="handleBack">
        {{ $t("accountInfo.返回") }}
      </van-button>
    </div>

    <VerifiedModal v-model="verifiedPopup" />
  </div>
</template>

<script>
import { getSelfAccountInfo } from "@/api/workOrder";
import storage from "@/utils/storage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {},
      verifiedPopup: false,
    };
  },
  computed: {
    ...mapGetters(["defaultRoleInfo"]),
    setCurrentChannel() {
      const { form } = this;
      if (form.account_info && form.account_info.channel) {
        const name = form.account_info.channelName;
        const channel = form.account_info.channel;
        if (name === "好游快爆" || name === "taptap") {
          return name;
        } else if (channel === "ihero") {
          return "iOS";
        } else if (channel === "hero") {
          return this.$t("accountInfo.官方安卓");
        } else {
          return name;
        }
      } else {
        return "";
      }
    },
    channelType() {
      const { form } = this;
      if (form.account_info && form.account_info.channel) {
        const name = form.account_info.channelName;
        const channel = form.account_info.channel;
        if (channel === "ihero" || channel === "hero") {
          return true;
        } else if (name === "好游快爆" || name === "taptap") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    is_verified() {
      const { is_verified } = this.$route.query;
      return this.defaultRoleInfo.is_verified === 0 && is_verified == 1;
    },
  },
  mounted() {
    if (this.is_verified) {
      this.verifiedPopup = true;
    } else {
      this.getAccountInfo();
    }
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
    getAccountInfo() {
      this.showLoading();
      const { session_id } = this.$route.query;
      const params = {
        game_id: storage.getGameId(),
        server_id: this.defaultRoleInfo.f_id,
        role_id: this.defaultRoleInfo.role_id,
        session_id: session_id ? Number(session_id) : undefined,
      };
      getSelfAccountInfo(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "account_info",
              game_id: storage.getGameId(),
              server_id: this.defaultRoleInfo.f_id,
              role_id: this.defaultRoleInfo.role_id,
            });
            this.form = res.data;
          }
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.account-box {
  width: 100%;
  .top {
    margin-bottom: 10px;
  }
}
</style>
